// GTM purchase conversion tracking
export const trackPurchase = (value, dedupeKey) => {
  const amount = Number(value);
  if (!amount || isNaN(amount) || amount <= 0) return;
  if (dedupeKey) {
    const k = `purchase_tracked_${dedupeKey}`;
    try {
      if (sessionStorage.getItem(k)) return;
      sessionStorage.setItem(k, '1');
    } catch (e) { /* storage unavailable — still track */ }
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'purchase_complete',
    value: Math.round(amount * 100) / 100,
    currency: 'GBP',
  });
};
